<template>
  <div
    class="tilda-page-wrapper"
    v-html="data.html"
  />
</template>

<script setup lang="ts">
  import type { TildaPage } from '@academica-box/swagger/academgen'

  const props = defineProps<{
    data: TildaPage
  }>()

  useHead({
    link: props.data.css.map(href => ({
      rel: 'stylesheet',
      href,
    })),
    script: props.data.js.map(src => ({
      type: 'text/javascript',
      src,
    }))
  })
</script>

<style>
  .tilda-page-wrapper {
    position: relative;
  }
</style>
